import React, { useState, useEffect, useMemo, useContext } from "react";
import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import MetaData from "../../../components/MetaData";
import logo_white from "../../../images/logo_white.png";
import logo_black from "../../../images/logo_black.png";
import {
  erp_image_1,
  erp_image_2_bg,
  erp_image_3_bg,
  erp_business_1,
  erp_business_2,
  erp_business_3,
  erp_business_4,
  erp_business_5,
  erp_business_6,
  erp_finance_module,
  erp_supply_chain,
  erp_production,
  erp_inventory_management,
  erp_purchase_module,
  erp_sales_module,
  credit_management_1,
  business_intelligence_1,
  asset_management_1,
  approval_management_1,
  advance_audit_1,
  communication_module,
  ecommerence_module,
  customer_portal,
  executive_insights,
  advance_audit_trail,
  cloud_base_backup,
} from "../../../images";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import FAQAccordion from "../../../components/FAQAccordion";
import "../../sass/home.scss";
import GoogleReviewSection from "../../../components/GoogleReviewSection";

const services = [
  {
    id: 1,
    title: "ERP Business Software",
    description:
      "SoftoRithm Technologies is offering its best ERP Business software product named Cognitive Solutions to its customer like distributors, manufacturers, wholesalers, retailers, marts, restaurants, pharmacies and others",
    link: "/services/erp-business-software",
    image: erp_business_1,
  },
  {
    id: 2,
    title: "Web Design",
    description:
      "Elevate your brand with Softorithm's exceptional Graphic and UI/UX Design services. Our adept team seamlessly merges creativity and functionality, delivering visually stunning designs.",
    link: "/services/web-design",
    image: erp_business_2,
  },
  {
    id: 3,
    title: "Web Development",
    description:
      "Unlock the potential of your online presence with our unparalleled frontend services. From the timeless versatility of HTML, empowering businesses with customizable and scalable solutions",
    link: "/services/web-development",
    image: erp_business_3,
  },
  {
    id: 4,
    title: "Digital Marketing",
    description:
      "Elevate your online presence with our comprehensive Digital Marketing services. Our expertise extends across On-Page SEO, ensuring your website is finely tuned for search engines.",
    link: "/services/digital-marketing",
    image: erp_business_4,
  },
  {
    id: 5,
    title: "Web App Development",
    description:
      "Unlock efficiency and innovation with our comprehensive web development services. From powerful ERP and HRM solutions to seamless PLM and PIM integrations, we specialize in crafting dynamic web portals tailored to your unique needs.",
    link: "/services/web-application-development",
    image: erp_business_5,
  },
  {
    id: 6,
    title: "Video Editing Marketing",
    description:
      "Elevate your brand with our top-notch 2D animation services. Our expert animators bring creativity and precision to every project, ensuring a captivating visual experience.",
    link: "/services/video-editing-marketing",
    image: erp_business_6,
  },
];

const staticReviews = [
  {
    id: 1,
    name: "Kimberly Noyce",
    rating: 5,
    text: "Highly recommend !!!! Ali did a great job with all of the projects I gave him. Lots of patience and very fast. Very knowledgeable with marketing, websites, social media platforms etc. Responded quickly to all of my questions and was very patient when I changed my mind on different things.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 2,
    name: "Benoit",
    rating: 5,
    text: "Thank you for your services for our business. Really satisfied with your service and reports.",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 3,
    name: "A-D Rehman",
    rating: 5,
    text: "I joined Softorithm for AI Creation and Graphic Designing classes, and it's been an amazing experience. The instructors are skilled, supportive, and make learning easy and practical. The courses are well-structured, blending real-world …More",
    timeAgo: "3 months ago",
    avatar:
      "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 4,
    name: "huzaifah butt",
    rating: 5,
    text: "SoftoRithm Technologies is an outstanding digital marketing agency. Their team is professional, and they know exactly what they are doing. They have provided me the best web development services. They are not only experts in web development …More",
    timeAgo: "2 months ago",
    avatar:
      "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 5,
    name: "AD",
    rating: 5,
    text: "The team of SoftoRithm Technologies is very cooperative and experienced. They have achieved all goals and given the perfect e-commerce website for my jewelry business. Highly recommend their affordable services in the region of Jalalpur Jattan.",
    timeAgo: "4 months ago",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 6,
    name: "Azeem Ashraf",
    rating: 5,
    text: "A great name in the SEO business. I've had the pleasure of working with them. Excellent services and exceptional customer service. Highly recommended for business of all sizes from all industries!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 7,
    name: "Muhammad Mubashir",
    rating: 5,
    text: "Best experience of SEO services. Really appreciated!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 8,
    name: "wahab ijaz",
    rating: 5,
    text: "Best SEO services provider.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 9,
    name: "Talha Ahmad",
    rating: 5,
    text: "Great. Highly Recommended. Keep it up!",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1547425260-76bcadfb4f2c?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 10,
    name: "saqib ali",
    rating: 5,
    text: "Great service. Satisfied.",
    timeAgo: "6 years ago",
    avatar: "",
  },
  {
    id: 11,
    name: "anonymous account",
    rating: 5,
    text: "Good and efficient service .. .Best quality",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 12,
    name: "Sadda Hussain",
    rating: 5,
    text: "Excellent SEO Services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1545996124-0501ebae84d0?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 13,
    name: "Waqar Khalid",
    rating: 5,
    text: "Excellent service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 14,
    name: "ch waqas",
    rating: 5,
    text: "Good servises👍👍👍",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 15,
    name: "Al Jehdami International",
    rating: 5,
    text: "Satisfied services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 16,
    name: "azaad panchii",
    rating: 5,
    text: "Good service",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?w=50&h=50&fit=crop&crop=face",
  },
  {
    id: 17,
    name: "pitbull planet",
    rating: 5,
    text: "Excelent services",
    timeAgo: "6 years ago",
    avatar:
      "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=50&h=50&fit=crop&crop=face",
  },
];

const videos = [
  {
    id: 1,
    title: "ERP Cognitive Solutions at GT Mart, Gujrat",
    youtubeUrl: "https://youtube.com/shorts/Gvz9XosXo6w?si=7kP0ZSv2R4G-nn25",
    thumbnail: "https://img.youtube.com/vi/Gvz9XosXo6w/maxresdefault.jpg",
  },
  {
    id: 2,
    title: "Bhaiya Trader Wholesaler, Gujrat",
    youtubeUrl: "https://youtube.com/shorts/2B1mzzdCnb4?si=71cpKFzphUfWXmDH",
    thumbnail: "https://img.youtube.com/vi/2B1mzzdCnb4/maxresdefault.jpg",
  },
  {
    id: 3,
    title: "Yashfa Mega Store, Jalalpur Jattan, District Gujrat",
    youtubeUrl: "https://youtube.com/shorts/_d_vAT5Uhh8?si=-7NMlfiV3zDZrceO",
    thumbnail: "https://img.youtube.com/vi/_d_vAT5Uhh8/maxresdefault.jpg",
  },
  {
    id: 4,
    title: "Lala G Cosmetics Store, Jalalpur Jattan, District Gujrat",
    youtubeUrl: "https://youtube.com/shorts/8P5QTEzZqKI?si=YKlVw0qmut8Oy2mR",
    thumbnail: "https://img.youtube.com/vi/8P5QTEzZqKI/maxresdefault.jpg",
  },
];

const getYouTubeEmbedUrl = (url) => {
  if (!url) return "";
  if (url.includes("embed")) return url;
  if (url.includes("/shorts/")) {
    const shortsMatch = url.match(/\/shorts\/([^?&#]+)/);
    if (shortsMatch && shortsMatch[1]) {
      return `https://www.youtube.com/embed/${shortsMatch[1]}`;
    }
  }
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  const videoId = match && match[2].length === 11 ? match[2] : null;
  if (videoId) return `https://www.youtube.com/embed/${videoId}`;
  return url;
};

const erpOfferColumns = [
  {
    id: "billing-and-entry",
    items: [
      {
        id: "quick-billing",
        label: "Quick Billing",
        desc: "Create customer bills in the shortest possible time.",
      },
      {
        id: "easy-bookkeeping",
        label: "Easy Bookkeeping",
        desc: "Maintain account ledgers with ease.",
      },
      {
        id: "bilingual-printing",
        label: "Bilingual Printing",
        desc: "Facility to print customer bills in both Urdu and English.",
      },
      {
        id: "flexible-bill-sizes",
        label: "Flexible Bill Sizes",
        desc: "Facility to print bills in 3 different sizes.",
      },
      {
        id: "data-entry-options",
        label: "Data Entry Options",
        desc: "Barcode scanner support and manual entry facility.",
      },
      {
        id: "printer-compatibility",
        label: "Printer Compatibility",
        desc: "Support for both thermal and laser jet printers.",
      },
    ],
  },
  {
    id: "stock-and-reports",
    items: [
      {
        id: "stock-reports",
        label: "Stock Reports",
        desc: "Complete reports for available (current) stock and sold stock.",
      },
      {
        id: "low-stock-alerts",
        label: "Low Stock Alerts",
        desc: "Instant reports for items that are out of stock.",
      },
      {
        id: "ledger-reports",
        label: "Ledger Reports",
        desc: "Reports for both customer and vendor accounts.",
      },
      {
        id: "financial-tracking",
        label: "Financial Tracking",
        desc: "Comprehensive reports for income and expenses.",
      },
      {
        id: "day-book",
        label: "Day Book",
        desc: "Facility for maintaining a daily journal/day book.",
      },
    ],
  },
];

const coreOperations = [
  {
    id: "finance",
    icon: erp_finance_module,
    title: "Finance",
    desc: "Integrated accounting software to streamline your business-wide operations.",
  },
  {
    id: "purchase",
    icon: erp_purchase_module,
    title: "Purchase Module",
    desc: "Efficiently manage your procurement process with our Cognitive Solutions ERP purchase module.",
  },
  {
    id: "sales",
    icon: erp_sales_module,
    title: "Sales Module",
    desc: "Streamline sales processes and drive revenue growth with our sales module.",
  },
  {
    id: "inventory",
    icon: erp_inventory_management,
    title: "Inventory Management",
    desc: "Optimize inventory management and increase efficiency with Cognitive Solutions ERP’s inventory module.",
  },
  {
    id: "production",
    icon: erp_production,
    title: "Production Module",
    desc: "Improve production processes and optimize resource allocation with business software.",
  },
  {
    id: "supply-chain",
    icon: erp_supply_chain,
    title: "Supply Chain",
    desc: "Improve operational efficiency across your entire distribution network.",
  },
];

const managementAccountability = [
  {
    id: "credit_management",
    icon: credit_management_1,
    title: "Credit Management",
    desc: "Enhance credit control and improve cash flow with our credit management module.",
  },
  {
    id: "advance_audit_trail",
    icon: advance_audit_1,
    title: "Advanced Audit Trail",
    desc: " Ensure data integrity and improve compliance withCognitive Solutions' advanced audit trail module.",
  },
  {
    id: "approval_management",
    icon: approval_management_1,
    title: "Approval Management",
    desc: "Streamline approval processes and enhance accountability with Cognitive Solutions' approval management module.",
  },
  {
    id: "asset_management",
    icon: asset_management_1,
    title: "Asset Management",
    desc: "Effectively manage company assets and enhance operational efficiency with Cognitive Solutions' asset management module.",
  },
  {
    id: "business_intelligence_reports",
    icon: business_intelligence_1,
    title: "Business Intelligence Reports",
    desc: "Gain valuable insights and make informed decisions with Cognitive Solutions' BI reports module.",
  },
];

const securityCommunication = [
  {
    id: "cloud_backup",
    icon: cloud_base_backup,
    title: "Cloud-Based Backup",
    desc: "Your data is safe. Even if your hardware has an issue, your records are backed up securely in the cloud.",
  },
  {
    id: "advanced_audit_trail",
    icon: advance_audit_trail,
    title: "Advanced Audit Trail",
    desc: "Monitor every transaction made on your system for complete accountability.",
  },
  {
    id: "executive_insights",
    icon: executive_insights,
    title: "Executive Insights",
    desc: "Use our mobile app or local reports to stay connected to your business performance.",
  },
  {
    id: "communication_module",
    icon: communication_module,
    title: "Communication Module",
    desc: "Improve your communication with customers and employees by keeping them updated with the email and SMS communication module.",
  },
  {
    id: "customer_portal",
    icon: customer_portal,
    title: "Customer Portal",
    desc: "Improve customer engagement and streamline communication with Cognitive Solutions' powerful Customer Portal module.",
  },
  {
    id: "ecommerce_module",
    icon: ecommerence_module,
    title: "E-Commerce Module",
    desc: "Boost your online presence and drive e-commerce growth with Cognitive Solutions' e-commerce module.",
  },
];

const securityCommunicationCards = [
  {
    id: "cloud_based_backup",
    title: "Cloud-Based Backup",
    desc: "Your data is safe. Even if your hardware has an issue, your records are backed up securely in the cloud.",
    icon: null, // TODO: replace with provided icon
  },
  {
    id: "advanced_audit_trail",
    title: "Advanced Audit Trail",
    desc: "Monitor every transaction made on your system for complete accountability and traceability.",
    icon: null, // TODO: replace with provided icon
  },
  {
    id: "executive_insights",
    title: "Executive Insights",
    desc: "Use real-time dashboards and reports to stay connected to your business performance anywhere.",
    icon: null, // TODO: replace with provided icon
  },
  {
    id: "communication_module",
    title: "Communication Module",
    desc: "Improve communication with customers and employees using integrated email and SMS tools.",
    icon: null, // TODO: replace with provided icon
  },
  {
    id: "customer_portal",
    title: "Customer Portal",
    desc: "Empower customers with self-service access and streamline engagement through a secure portal.",
    icon: null, // TODO: replace with provided icon
  },
  {
    id: "ecommerce_module",
    title: "E-Commerce Module",
    desc: "Boost your online presence and manage end-to-end e-commerce operations from a single platform.",
    icon: null, // TODO: replace with provided icon
  },
];

const ERP = () => {
  const navigate = useNavigate();
  const { themeColor } = useContext(ThemeContext);
  const isDarkTheme = themeColor === "#181818";
  const logoImage = isDarkTheme ? logo_black : logo_white;

  const [reviewItems, setReviewItems] = useState(2);
  const [expandedReviews, setExpandedReviews] = useState({});
  const MAX_REVIEW_CHARS = 120;

  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setReviewItems(1);
    } else {
      setReviewItems(2);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const reviewCarouselOptions = useMemo(
    () => ({
      loop: true,
      margin: 30,
      responsiveClass: true,
      dots: false,
      nav: true,
      rewind: true,
      autoplay: true,
      smartSpeed: 700,
      autoplayTimeout: 5000,
      responsive: {
        0: { items: 1 },
        768: { items: 2 },
      },
    }),
    [],
  );

  const handleButtonClick = () => {
    // Handle button click - you can navigate to a specific page or perform any action
    console.log("See Our Work button clicked");
  };

  return (
    <div className="pg_bdy services_erp_page">
      <MetaData
        metaTitle={"ERP Business Software"}
        metaDescription={
          "SoftoRithm Technologies offers Cognitive Solutions - the best ERP Business software for distributors, manufacturers, wholesalers, retailers, marts, restaurants, pharmacies and others."
        }
      />

      {/* Section 1 - Hero */}
      <GoogleReviewSection
        title="ERP Business Sofware"
        subtitle="Expert HTML, WordPress, and React.js development services that create fast, responsive, and user-friendly web applications. Trusted by businesses worldwide for over 12 years."
        buttonText="See Our Work"
        onButtonClick={handleButtonClick}
        companyName="Softorithm"
      />

      {/* Section 2 - What We Offer In Our ERP Business Software */}
      <section className={`erp_offer_section ${isDarkTheme ? 'erp_offer_section_dark' : ''}`}>
        <Container>
          <div className="text-center py-5">
            <h2 className="erp_offer_title">
              What We Offer In Our ERP Business Software
            </h2>
          </div>
          <Row className="justify-content-center">
            {erpOfferColumns.map((column) => (
              <Col
                key={column.id}
                lg={5}
                md={6}
                sm={12}
                className="mb-4 d-flex"
              >
                <div className="erp_offer_card">
                  <ul className="erp_offer_list">
                    {column.items.map((item) => (
                      <li key={item.id}>
                        <span className="erp_offer_icon p-1">
                          <i className="ri-check-line" />
                        </span>
                        <div className="erp_offer_text">
                          <span className="erp_offer_label mb-2">
                            {item.label}
                          </span>
                          <span className="erp_offer_desc">{item.desc}</span>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <button
                    type="button"
                    className="erp_offer_btn"
                    onClick={handleButtonClick}
                  >
                    Get Quote
                  </button>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Section 3 - ERP Modules Intro (radial gradient background) */}
      <section className="erp_modules_section">
        <Container>
          <div className="text-center my-3">
            <h2 className="erp_modules_title">
              Cognitive Solutions ERP Modules
            </h2>
            <p className="erp_modules_subtitle">
              Cognitive Solutions is a robust desktop-based software designed
              for high-performance business management. Installed directly on
              your computer or laptop, it provides a fast, reliable offline
              experience with the added security of cloud-based data backup.
            </p>
          </div>
        </Container>
      </section>

      {/* Section 4 - Core Operations of our Business Software */}
      <section className="core_operations_section">
        <Container>
          <div className="text-center ">
            <h2 className="core_operations_title  pb-5">
              Core Operations of our Business Software
            </h2>
          </div>

          <Row className="core_operations_grid">
            {coreOperations.map((operation) => (
              <Col
                key={operation.id}
                lg={4}
                md={6}
                sm={12}
                className="mb-4 d-flex"
              >
                <div className="core_operation_card">
                  <div className="core_operation_icon">
                    <img
                      src={operation.icon}
                      alt={operation.title}
                      className="core_operation_icon_img"
                      style={{
                        filter: isDarkTheme
                          ? "brightness(0) invert(1)"
                          : "none",
                      }}
                    />
                  </div>
                  <h3 className="core_operation_name">{operation.title}</h3>
                  <p className="core_operation_desc">{operation.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Section 5 */}
      <section className="management_accountability_section">
        <Container>
          <div className="text-center mb-4">
            <h2 className="management_accountability_title">
              Management & Accountability
            </h2>
          </div>
          <Row className="management_accountability_grid py-4">
            {managementAccountability.map((operation) => (
              <Col
                key={operation.id}
                lg={4}
                md={6}
                sm={12}
                className="mb-4 d-flex"
              >
                <div className="management_accountability_card">
                  <div className="management_accountability_icon">
                    <img
                      src={operation.icon}
                      alt={operation.title}
                      className="management_accountability_icon_img"
                      style={{
                        filter: isDarkTheme
                          ? "brightness(0) invert(1)"
                          : "none",
                      }}
                    />
                  </div>
                  <h3 className="management_accountability_name">
                    {operation.title}
                  </h3>
                  <p className="management_accountability_desc">
                    {operation.desc}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Section 6 - Security, Communication & Digital Transformation */}
      <section className="security_communication_section">
        <Container>
          <div className="text-center mb-4">
            <h2 className="security_communication_title pb-4">
              Security, Communication & Digital Transformation
            </h2>
          </div>
          <Row className="security_communication_grid">
            {securityCommunication.map((item) => (
              <Col
                key={item.id}
                lg={4}
                md={6}
                sm={12}
                className="mb-4 d-flex"
              >
                <div className="security_communication_card">
                  <div className="security_communication_icon">
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="security_communication_icon_img"
                      style={{
                        filter: isDarkTheme
                          ? "brightness(0) invert(1)"
                          : "none",
                      }}
                    />
                  </div>
                  <h3 className="security_communication_name">
                    {item.title}
                  </h3>
                  <p className="security_communication_desc">{item.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Section 7 - CTA Section */}
      <section className="erp_cta_section">
        <Container>
          <Row className="align-items-center">
            <Col lg={8} md={7} sm={12} className="mb-3 mb-md-0">
              <p className="erp_cta_text">
                Would you like to take full control of billing, stock, and
                financial reports in real time and track every product,
                transaction, and every rupee – all in one system
              </p>
            </Col>
            <Col lg={4} md={5} sm={12} className="text-center text-md-center">
              <button
                type="button"
                className="erp_cta_btn"
                onClick={handleButtonClick}
              >
                Call Us Today!
              </button>
            </Col>
          </Row>
        </Container>
      </section>


        {/* Section 8 - FAQ Section */}
         {/* FAQ Section */}
                <div
                  className="faq_section py-3"
                  style={{ backgroundColor: "var(--body-bg-color, #f8f9fa)" }}
                >
                  <Container>
                    
                    <Row className="justify-content-center">
                      <Col lg={6}>
                      <div className="faq_header text-center mb-5">
                      <h3
                        className="mb-3"
                        style={{
                          color: "var(--text-color, #333333)",
                          fontSize: "25px",
                          fontWeight: "bold",
                        }}
                      >
                        Frequently Asked Questions (FAQs)
                      </h3>
                    </div>
                        <FAQAccordion
                          faqData={[
                            {
                              question: "What exactly does SoftoRithm Technologies do?",
                              points: [
                                'SoftoRithm Technologies helps businesses become smarter and more organized through technology. We\'re a team of tech experts who do two big things: we give you Cognitive Solutions (our smart software) to organize your internal work, and we handle your Web Design, SEO, and Marketing to help you grow externally. Basically, we handle the tech so you can focus on the "business."',
                              ],
                            },
                            {
                              question:
                                'What is "Cognitive Solutions" and why should I care?',
                              points: [
                                "Think of it as the ultimate personal assistant for your business. If you’re currently juggling messy spreadsheets, paper receipts, or three different apps just to check your stock, you need this. It brings your sales, inventory, and accounts into one simple dashboard. You’ll save time, stop making manual errors, and finally know exactly how much profit you’re making in real-time.",
                              ],
                            },
                            {
                              question:
                                "Is this only for big companies, or can a small shop use it too?",
                              points: [
                                "You don’t need to be a giant corporation to work with us. Whether you’re running a single retail shop, a local mart, or a growing distribution business, we’ve got you. We scale our services to fit your size and budget. Small businesses actually need this the most because it frees up your time to grow!",
                              ],
                            },
                            {
                              question:
                                "Do you provide support and training after installation?",
                              points: [
                                'Not a chance. We know that "new software" can feel intimidating. That’s why we sit down with you and your team to provide full training until everyone feels like a pro. And if you ever have a question or a glitch down the road, we’re just a phone call or a message away. We’re in this for the long haul.',
                              ],
                            },
                            {
                              question:
                                "Can the ERP software be customized according to my business requirements?",
                              points: [
                                'Every business has its own "secret sauce," and we don\'t want to change that. We don\'t just give you a "one-size-fits-all" box. We’ll look at how you actually work and then tweak Cognitive Solutions to match—whether that’s a specific billing style, special discounts, or custom reports that you actually find useful.',
                              ],
                            },
                            {
                              question: "How safe is my business data with you?",
                              points: [
                                'We treat your data with the same care we\'d treat our own. Our system is built with serious security layers and "user permissions"—meaning you get to decide exactly who can see what. Plus, we set up backups so that even if the unexpected happens, your business records stay safe and sound.',
                              ],
                            },
                          ]}
                        />
                      </Col>
                      <Col lg={6}>

                      <div className="faq_header text-center mb-5">
                      <h2
                        className="mb-3"
                        style={{
                          color: "var(--text-color, #333333)",
                          fontSize: "25px",
                          fontWeight: "bold",
                        }}
                      >
                        Hardware & Technical (FAQs)
                      </h2>
                    </div>
                        <FAQAccordion
                          faqData={[
                            {
                              question:
                                "Do you only offer ERP software or complete digital solutions?",
                              points: [
                                'We sure do. We\'re a "full-service" digital partner. While our ERP handles the "engine" of your business, our creative team handles the "paint job." From building modern websites and catchy Video Editing Marketing to getting you on the first page of Google with SEO, we make sure you look as good as you operate.',
                              ],
                            },
                            {
                              question:
                                "How can I get started with SoftoRithm Technologies?",
                              points: [
                                'It’s super easy. No high-pressure sales pitches here—just a simple chat. Reach out for a free consultation, tell us where your business is feeling "stuck," and we’ll show you exactly how we can fix it. No tech jargon, just honest solutions to help you move forward.',
                              ],
                            },
                            {
                              question:
                                "What to do if I don’t get my answer here?",
                              points: [
                                "No problem! You can send your query on the contact form and one of our customer support representatives will contact you as soon as possible. You can also visit our office for in-person meetings.",
                              ],
                            },
                            {
                              question:
                                "How much time do you take to respond against a query?",
                              points: [
                                "We try our best to get back to our customers as soon as possible. Usually, you will get a response within 24 to 48 hours.",
                              ],
                            },
                            {
                              question:
                                "Do I have to be local to get the desired services?",
                              points: [
                                "No, you can contact us to get our services from any part of the world. We have a proper management system that allows us to connect with our clients in any corner of the world. You will get the best services irrespective of the place without any compromise on the quality. Our crew is skilled enough to handle the tasks remotely.",
                              ],
                            },
                            {
                              question:
                                "What makes SoftoRithm Technologies better than the competition?",
                              points: [
                                "SoftoRithm Technologies is one of the renowned companies with a proven track record of providing the best services. The competent crew has more than 10 years of experience and you will get the quality services regarding digital marketing, SEO, web designing, web development, app development, and business consulting. You will not have any regrets once you will hire us. We are here for your assistance.",
                              ],
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                  </Container>
                </div>
      
    </div>
  );
};

export default ERP;
